// @flow
import { TAB } from 'Client/cms/toolkit/constants';

export const tabResolver = {
  name: TAB,
  props() {
    return {
      header(props: { anchor: string, icon: string, title: string }) {
        const data: {
          title: string,
          id?: string,
          iconName?: string,
        } = {
          title: props.title,
        };

        if (props.anchor) {
          data.id = props.anchor;
        }

        if (props.icon) {
          data.iconName = props.icon;
        }

        return data;
      },
    };
  },
};
